/**
 * @generated SignedSource<<5f526b05c04f2de04d3d04fa0617b3dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PodcastWithTimestamp_PodcastWithTimestampElementFragment$data = {
  readonly duration: number;
  readonly end: number;
  readonly podcastFile: {
    readonly url: string | null;
  };
  readonly start: number;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"DynamicImageDisplayComponent_PodcastWithTimestampElementFragment">;
  readonly " $fragmentType": "PodcastWithTimestamp_PodcastWithTimestampElementFragment";
};
export type PodcastWithTimestamp_PodcastWithTimestampElementFragment$key = {
  readonly " $data"?: PodcastWithTimestamp_PodcastWithTimestampElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PodcastWithTimestamp_PodcastWithTimestampElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PodcastWithTimestamp_PodcastWithTimestampElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "podcastFile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DynamicImageDisplayComponent_PodcastWithTimestampElementFragment"
    }
  ],
  "type": "PodcastWithTimestampLearnElement",
  "abstractKey": null
};

(node as any).hash = "df234a74e6a6fe7a51b7178a0fed2ac1";

export default node;
